<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.1848 8.87325L18.185 8.18724L17.0929 6H12.6845H11.3094H6.90406L5.81196 8.18724L4.81215 8.87325L4 11.1866V11.3743V15.9979V17.9975H7.31321V15.9979H16.6868V17.9975H20V15.9979V11.3743V11.1866L19.1848 8.87325ZM18.6833 14.6843H5.31052V11.4973L5.90425 9.77767L6.81177 9.18395L7.68544 7.37202H11.3094H12.6845H16.3084L17.1821 9.18395L18.0896 9.77767L18.6833 11.4973V14.6843Z"
      class="fill-current"
    />
    <path d="M5.99902 12.6845H8.30935V11.9985L5.99902 11.374V12.6845Z" class="fill-current" />
    <path
      d="M9.40479 11.9985H9.3125V12.6845C9.3125 13.0383 9.44171 13.3459 9.70319 13.6074C9.96468 13.8689 10.26 13.9981 10.5923 13.9981H10.6845H13.3087H13.4009C13.7332 13.9981 14.0316 13.8689 14.29 13.6074C14.5515 13.3459 14.6807 13.0414 14.6807 12.6845V11.9985H14.5884H9.40479Z"
      class="fill-current"
    />
    <path d="M15.6836 12.6845H17.997V11.374L15.6836 11.9985V12.6845Z" class="fill-current" />
  </svg>
</template>
